// libs
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber, LocaleString } from '@biw/intl';
import get from 'lodash/get';

import Table from './table';

export default class AccountHistory extends React.Component {
    static propTypes = {
        accountHistory: PropTypes.shape( {
            accountNumber: PropTypes.string
        } ),
        sortAccountHistory: PropTypes.func.isRequired,
        showMoreAccountHistory: PropTypes.func.isRequired,
        accountBalance: PropTypes.shape( {
            result: PropTypes.number
        } ),
        mediaLabel: PropTypes.string
    };

    static defaultProps = {
        mediaLabel: ''
    };

    render() {
        const {
            accountHistory,
            sortAccountHistory,
            showMoreAccountHistory,
            accountBalance,
            mediaLabel
        } = this.props;
        return (
            <div className="account-history">
                <LocaleString TextComponent="h3" code="profile.accountHistoryTitle" />

                <div className="account-info">
                    <div>
                        <LocaleString
                            className="client-primary-text"
                            TextComponent="h4"
                            code="profile.accountNumberLabel"
                        />
                        <br />
                        <p>{accountHistory.accountNumber}</p>
                    </div>
                    <div>
                        <LocaleString
                            className="client-primary-text"
                            TextComponent="h4"
                            code="profile.currentBalanceLabel"
                        />
                        <br />
                        <p><FormattedNumber value={accountBalance.result} /> {mediaLabel}</p>
                    </div>
                </div>

                { get( accountHistory, 'displayRows.length', 0 ) ? (
                    <Table
                        accountHistory={accountHistory}
                        sortAccountHistory={sortAccountHistory}
                        showMoreAccountHistory={showMoreAccountHistory}
                    />
                ) : (
                    <div className="no-history-found-wrapper">
                        <LocaleString code="profile.accountHistoryNotFoundMessage" />
                    </div>
                )}
            </div>
        );
    }
}
